// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__3h3XA"};